import React, { useState } from 'react';
import axios from 'axios';
import './reviewservice.css'
import { useParams } from 'react-router-dom';


function ReviewService() {
    const { id } = useParams()
    const [postReview, setPostReview] = useState({
        "user_id": "",
        "movie_id": id,
        "review_headline": "",
        "review_detail": "",
        "score": 0
    })
    function submit(e) {
        e.preventDefault();
        const postToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjp7ImlkIjoiNjBjODdiMTA5YjQwZWUxMzU0ZmYzMmU1IiwibmFtZSI6InVzZXJuYW1lXzkiLCJlbWFpbCI6InVzZXJuYW1lXzlAZ21haWwuY29tIiwidXNlcm5hbWUiOiJ1c2VybmFtZV85Iiwicm9sZSI6InVzZXIifSwiaWF0IjoxNjIzOTI1NTEyLCJleHAiOjE2MjY1MTc1MTJ9.yUsEj2ypTxrVLp5RnpVGIU0SzUtfXT4YM0sHlPo22bw"
        axios({
            method: 'POST',
            url: "https://moviesteamd.herokuapp.com/api/v1/review",
            headers: {
                "Content-type": "application/json",
                Authorization: postToken
            },
            body: JSON.stringify({
                "user_id": "",
                "movie_id": "",
                "review_headline": "",
                "review_detail": "",
                "score": 0
            })
        })
            .then(res => {
                console.log(res)
            })
        const putToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjp7ImlkIjoiNjBjODdiMTA5YjQwZWUxMzU0ZmYzMmU1IiwibmFtZSI6InVzZXJuYW1lXzkiLCJlbWFpbCI6InVzZXJuYW1lXzlAZ21haWwuY29tIiwidXNlcm5hbWUiOiJ1c2VybmFtZV85Iiwicm9sZSI6InVzZXIifSwiaWF0IjoxNjIzOTI0Nzc5LCJleHAiOjE2MjY1MTY3Nzl9.JfXtiOKHCnK_5FiJ0khnN6U14leFMJcD41DjF08skD8"
        axios({
            method: 'PUT',
            url: "https://moviesteamd.herokuapp.com/api/v1/review/60cc0b71112c1542224eccc4",
            headers: {
                "Content-type": "application/json",
                Authorization: putToken
            },
            body: JSON.stringify({
                "user_id": "",
                "movie_id": "",
                "review_headline": "",
                "review_detail": "",
                "score": 0
            })
        })
            .then(res => {
                console.log(res)
            })
    }
    function handleAddReview(e) {
        const newPostReview = { ...postReview }
        newPostReview[e.target.name] = e.target.value
        setPostReview(newPostReview)
        console.log(newPostReview)
    }

    return (
        <div>
            <form onSubmit={(e) => submit(e)}>
                <textarea className="comment-field"
                    type="text"
                    placeholder="Leave a review here"
                    name="review_headline"
                    value={postReview.review_headline}
                    onChange={(e) => handleAddReview(e)}
                />
                <button className="submit-btn" type="submit" >Submit</button>
            </form>
            <button className="update-btn">Edit</button>
        </div>
    );
}

export default ReviewService;